import { render, staticRenderFns } from "./PromotionSwiperContainer.vue?vue&type=template&id=49f38dc8&scoped=true"
import script from "./PromotionSwiperContainer.vue?vue&type=script&lang=ts&setup=true"
export * from "./PromotionSwiperContainer.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PromotionSwiperContainer.vue?vue&type=style&index=0&id=49f38dc8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f38dc8",
  null
  
)

export default component.exports